module.exports = "pegasus/assets/blocks/header-5-theme2.png";